import { Button, Card } from "react-bootstrap";
import project1 from "../assets/img/greetingsUI.png";
import "./ProjectCard.css";

export const ProjectCard = ({ project, viewProject }) => {
    return (
        <>
            <Card className="project-card m-lg-2 my-2">
                <Card.Img variant="top" src={project.imgUrl} />
                <Card.Body>
                    <Card.Title>{project.name}</Card.Title>
                    <Card.Text>
                        {project.shortDescription}
                        {
                            project.technologies.map((tech, index) => (
                                index < 2 ? <span className="badge bg-primary mx-1" key={index}>{tech}</span> : ""
                            ))
                        }
                    </Card.Text>
                    <div className="project-links d-flex justify-content-between">
                        <Card.Link href={project.sourceCodeUrl} target="_blank" ><i className="bi bi-github"></i></Card.Link>
                        <Button className="view-project-btn border-0" onClick={viewProject} >view project</Button>
                        <Card.Link href={project.liveUrl} target="_blank" ><i className="bi bi-box-arrow-up-right"></i></Card.Link>
                    </div>
                </Card.Body>
            </Card>
        </>
    )
}